/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RecentSpin } from './RecentSpin';
import {
    RecentSpinFromJSON,
    RecentSpinFromJSONTyped,
    RecentSpinToJSON,
} from './RecentSpin';
import type { HealthBucket } from './HealthBucket';
import {
    HealthBucketFromJSON,
    HealthBucketFromJSONTyped,
    HealthBucketToJSON,
} from './HealthBucket';
import type { S2WGame } from './S2WGame';
import {
    S2WGameFromJSON,
    S2WGameFromJSONTyped,
    S2WGameToJSON,
} from './S2WGame';
import type { ErrorMessageCount } from './ErrorMessageCount';
import {
    ErrorMessageCountFromJSON,
    ErrorMessageCountFromJSONTyped,
    ErrorMessageCountToJSON,
} from './ErrorMessageCount';

/**
 * Spin health with the spin to win games, so spins can be shown by game name.
 * @export
 * @interface SpinHealthWithGames
 */
export interface SpinHealthWithGames {
    /**
     * Counts per time slot, oldest first, covering the whole window.
     * @type {Array<HealthBucket>}
     * @memberof SpinHealthWithGames
     */
    buckets: Array<HealthBucket>;
    /**
     * Length of each time slot in buckets
     * @type {number}
     * @memberof SpinHealthWithGames
     */
    bucketMinutes: number;
    /**
     * Newest spins first.
     * @type {Array<RecentSpin>}
     * @memberof SpinHealthWithGames
     */
    recentSpins: Array<RecentSpin>;
    /**
     * Most frequent error messages, most frequent first.
     * @type {Array<ErrorMessageCount>}
     * @memberof SpinHealthWithGames
     */
    errorMessages: Array<ErrorMessageCount>;
    /**
     * Share of spins that errored or are stuck, from 0 to 1.
     * @type {number}
     * @memberof SpinHealthWithGames
     */
    failureRate: number;
    /**
     * Spins still pending more than 5 minutes after they started, which means the spin never finished.
     * @type {number}
     * @memberof SpinHealthWithGames
     */
    stuckPending: number;
    /**
     * 
     * @type {number}
     * @memberof SpinHealthWithGames
     */
    error: number;
    /**
     * 
     * @type {number}
     * @memberof SpinHealthWithGames
     */
    complete: number;
    /**
     * 
     * @type {number}
     * @memberof SpinHealthWithGames
     */
    total: number;
    /**
     * 
     * @type {Date}
     * @memberof SpinHealthWithGames
     */
    windowStart: Date;
    /**
     * 
     * @type {Array<S2WGame>}
     * @memberof SpinHealthWithGames
     */
    games: Array<S2WGame>;
}

/**
 * Check if a given object implements the SpinHealthWithGames interface.
 */
export function instanceOfSpinHealthWithGames(value: object): value is SpinHealthWithGames {
    if (!('buckets' in value) || value['buckets'] === undefined) return false;
    if (!('bucketMinutes' in value) || value['bucketMinutes'] === undefined) return false;
    if (!('recentSpins' in value) || value['recentSpins'] === undefined) return false;
    if (!('errorMessages' in value) || value['errorMessages'] === undefined) return false;
    if (!('failureRate' in value) || value['failureRate'] === undefined) return false;
    if (!('stuckPending' in value) || value['stuckPending'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    if (!('complete' in value) || value['complete'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('windowStart' in value) || value['windowStart'] === undefined) return false;
    if (!('games' in value) || value['games'] === undefined) return false;
    return true;
}

export function SpinHealthWithGamesFromJSON(json: any): SpinHealthWithGames {
    return SpinHealthWithGamesFromJSONTyped(json, false);
}

export function SpinHealthWithGamesFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpinHealthWithGames {
    if (json == null) {
        return json;
    }
    return {
        
        'buckets': ((json['buckets'] as Array<any>).map(HealthBucketFromJSON)),
        'bucketMinutes': json['bucketMinutes'],
        'recentSpins': ((json['recentSpins'] as Array<any>).map(RecentSpinFromJSON)),
        'errorMessages': ((json['errorMessages'] as Array<any>).map(ErrorMessageCountFromJSON)),
        'failureRate': json['failureRate'],
        'stuckPending': json['stuckPending'],
        'error': json['error'],
        'complete': json['complete'],
        'total': json['total'],
        'windowStart': (new Date(json['windowStart'])),
        'games': ((json['games'] as Array<any>).map(S2WGameFromJSON)),
    };
}

export function SpinHealthWithGamesToJSON(value?: SpinHealthWithGames | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'buckets': ((value['buckets'] as Array<any>).map(HealthBucketToJSON)),
        'bucketMinutes': value['bucketMinutes'],
        'recentSpins': ((value['recentSpins'] as Array<any>).map(RecentSpinToJSON)),
        'errorMessages': ((value['errorMessages'] as Array<any>).map(ErrorMessageCountToJSON)),
        'failureRate': value['failureRate'],
        'stuckPending': value['stuckPending'],
        'error': value['error'],
        'complete': value['complete'],
        'total': value['total'],
        'windowStart': ((value['windowStart']).toISOString()),
        'games': ((value['games'] as Array<any>).map(S2WGameToJSON)),
    };
}

